import React, { useEffect, useRef } from 'react';
import Head from 'next/head';
import ContactMsg from '../components/Contact/ContactMsg';
import PageHero from '../layouts/PageHero';
import ContactHeader from '../components/Contact/Header';
import OurLocation from '../components/Contact/Location';
import Adventure from '../components/Reviews/Adventure';
import { useQuery } from '@apollo/client';
import { FAQ_CONTENT, FAQ_PAGE_INTERFACE } from '../api/faqPage';
import client from '../apollo-client';
import Faqs from '../components/Contact/Faqs';
import dynamic from 'next/dynamic';
const Newsletter = dynamic(() => import('../layouts/Newsletter/Newsletter'));
import { CONTACT_PAGE, CONTACT_PAGE_INTERFACE } from '../api/contactPage';
import { useRouter } from 'next/router';
import { replaceTripshepherdWithSeeSight } from '../utils/trip-sheppered-text';

interface IProps {
  faqs: any;
  headData: {
    title: string;
    metaDescription: string;
  };
}
const canada_address: string[] = [
  '5400 Robinson St',
  'Niagara Falls',
  'ON L2G 2A6'
];

const usa_address: string[] = [
  '310 Pine Ave',
  'Niagara Falls',
  'NY 14301, United States'
];

const Contact = ({ faqs, headData }: IProps) => {
  const router = useRouter();
  const faqRef = useRef<HTMLDivElement>(null);
  const { data, loading, error } =
    useQuery<CONTACT_PAGE_INTERFACE>(CONTACT_PAGE);

  useEffect(() => {
    if (router.query.faq === 'true')
      faqRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [router.query.faq]);
  const title = 'See Sight Tours - Contact us';

  return (
    <>
      <Head>
        <meta
          name="og:title"
          content={replaceTripshepherdWithSeeSight(headData.title)}
        />

        <meta
          name="og:description"
          content={replaceTripshepherdWithSeeSight(headData.metaDescription)}
        />
        <title>{title}</title>

        <meta
          name="description"
          content={replaceTripshepherdWithSeeSight(headData.metaDescription)}
        />
        <link href="https://www.seesight-tours.com/contact" rel="canonical" />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
      </Head>
      <PageHero
        title="CONTACT US"
        snippet="We'd love to hear from you"
        media="https://res.cloudinary.com/see-sight-tours/image/upload/q_auto,f_auto,c_fill,g_faces,h_570,w_1920,y_0/v1582036498/Happy-group-tour-guides.jpg"
        video={false}
      />
      <div id="Contact" className="pb-8">
        <ContactHeader />
        <ContactMsg />
        <OurLocation
          canada_address={canada_address}
          usa_address={usa_address}
        />
        <div className="w-full md:w-[90%] mx-auto py-10 px-5">
          <Faqs
            header={faqs?.sectionHeader}
            subHeader={faqs?.sectionSubheader}
            content={faqs?.sectionContent}
            faqRef={faqRef}
            contact={true}
          />
        </div>

        <Adventure />
        <Newsletter />
      </div>
    </>
  );
};
export async function getStaticProps() {
  const { data: faqs, error } = await client.query<FAQ_PAGE_INTERFACE>({
    query: FAQ_CONTENT
  });
  return {
    props: {
      faqs: faqs?.faqPage,
      headData: {
        title: faqs?.faqPage.pageTitle,
        metaDescription: faqs.faqPage.metaDescription
      }
    }
  };
}
export default Contact;
